import React from 'react';
import WidgetToolbar from 'widgets/WidgetToolbar/WidgetToolbar';

import MyPortfolioCapsulesSettings, {
    MyPortfolioCapsulesSettingsText,
} from 'widgets/myPortfolioCapsules/components/toolbar/MyPortfolioCapsulesSettings';
import { useWidgetContext } from 'widgets/WidgetContext';
import './MyPortfolioCapsulesToolbar.scss';
import WidgetToolbarShowHidePanel from 'widgets/WidgetToolbarShowHidePanel/WidgetToolbarShowHidePanel';
import classNames from 'classnames';
import { useMyPortfolioCapsulesConfigSlice } from 'widgets/myPortfolioCapsules/store/config/configSlice';
import { getTopic } from 'widgets/myPortfolioCapsules/topics/Topic';
import { ShareWidgetConfigToolbarButton } from 'widgets/configSharing/shareWidgetConfigModal/ShareWidgetConfigToolbarButton';

export const MyPortfolioCapsulesModalClassName =
    'MyPortfolioCapsulesSettingsModal';

export default function MyPortfolioCapsulesToolbar() {
    const { width } = useWidgetContext();
    const { config } = useMyPortfolioCapsulesConfigSlice();

    const configured = config.capsuleType && config.topic;
    const mustShow = !configured;

    const settingsCssClasses = classNames(MyPortfolioCapsulesModalClassName);

    let toolbarItems: JSX.Element | undefined = undefined;
    if (configured) {
        const topic = getTopic(config.topic!);
        toolbarItems = topic.toolbarItems;
    }

    return (
        <WidgetToolbarShowHidePanel mustShow={mustShow}>
            <div
                className="MyPortfolioCapsulesToolbar panel-header"
                style={{
                    width: width + 'px',
                }}
            >
                {toolbarItems && (
                    <div className="toolbar-items panel-header">
                        <div className={'toolbar'}>{toolbarItems}</div>
                    </div>
                )}
                <WidgetToolbar
                    settingsHeader={MyPortfolioCapsulesSettingsText}
                    settingsBody={<MyPortfolioCapsulesSettings />}
                    settingsTriggerText={MyPortfolioCapsulesSettingsText}
                    showEditLayout={false}
                    settingsClassName={settingsCssClasses}
                    fixedItems={<ShareWidgetConfigToolbarButton />}
                />
            </div>
        </WidgetToolbarShowHidePanel>
    );
}
